import createCustomerForm from './createCustomerFormModel';
const {
  formField: {
    // DATOS CLIENTE 
    name,
    address,
    email,
    person_in_charge,
    contact,
    second_person_in_charge,
    second_customer_contact,
    phone,
    start_date,
    status,
    country,
    departament,
    municipaly,
    applications,
    has_trial,
    trial_ends_at,
    subscription_ends_at
  } 
} = createCustomerForm;

export default {
  [name.name]: '',
  [address.name]: '',
  [email.name]: '',
  [person_in_charge.name]: '',
  [contact.name]: '',
  [second_person_in_charge.name]: '',
  [second_customer_contact.name]: '',
  [phone.name]: '',
  [start_date.name]: new Date(),
  [status.name]: true,
  [country.name]: '',
  [departament.name]: '',
  [municipaly.name]: '',
  [applications.name]: null,
  [has_trial.name]: false,
  [trial_ends_at.name]: null,
  [subscription_ends_at.name]: null

};

